import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    return React.createElement('button', { 'onClick': () => this.props.dispatchSubscriptionPage(this.props.promotion) }, '\n  ', this.props.children, '\n');
}